// extracted by mini-css-extract-plugin
export default {"receiptValidation":"uploadCreditReceiptForm_receiptValidation__ei9VP"};